import React, { useState } from 'react'
import ApexChart from "react-apexcharts"


const DonutChart = (props: any) => {


    const [seriesData, setSeriesData] = useState([props.emails, props.chats])

    let options: any = {
		chart: {
			type: 'donut',
		},
		plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                vertical: true,
                dataLabels: {
                    position: 'top'
                }
            }
        },
		labels: ['Emails', 'Chats'],
		
		dataLabels: {
            enabled: true,
            style: {
                colors: ['#333'],
                fontSize: '12px',
                fontFamily: 'inherit',
                fontWeight: 'normal',
            },
			dropShadow: {
				enabled: false,
			},
            offsetX: 30,
            formatter: (value: any, { seriesIndex, dataPointIndex, w }: any) => {return w.config.series[seriesIndex]}
        },
		title: {
			text: 'Total Conversations',
			align: 'left',
			margin: 10,
			offsetX: 0,
			offsetY: 0,
			floating: false,
			style: {
			fontSize:  '14px',
			fontWeight:  'bold',
			fontFamily:  undefined,
			color:  '#263238'
			},
		}
    }  

    return (
            <ApexChart
                options={options}
                series={seriesData}
                type="donut"
                height={230}
            />
    )
}

export default DonutChart
